import amandaPic from "@/public/images/artists/amanda.png";
import { Artist } from "@/types/types";

export const amanda = {
  id: "137",
  name: "Amanda",
  image: amandaPic,
  description: `Amanda's voice is smooth and emotive, resonating with a melancholic elegance akin to Lana Del Rey. Her versatile and delicate tones lend themselves beautifully to indie, alternative, and cinematic music, as well as contemporary pop and dance genres.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Famanda-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Pop", "Dance", "Unprocessed", "Indie", "Folk", "Falsetto"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Very high",
      },
      specific: {
        low: 55,
        high: 74,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
